import axios from 'axios'
import { cache } from '../decorators/cache.decorator'

class AppConfigService {
  configValues = null

  @cache
  async _queryConfig () {
    const queryResult = await axios.get('/api/config')
    this.configValues = queryResult.data
    return this.configValues
  }

  async getConfigValue (value) {
    this.configValues = await this._queryConfig()
    return this.configValues ? this.configValues[value] : null
  }

  getConfigValueSync (value) {
    return this.configValues ? this.configValues[value] : null
  }
}

export default new AppConfigService()
